<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
  // Import Font Awesome Icons Set
  $fa-font-path: "~font-awesome/fonts/";
  @import "~font-awesome/css/font-awesome.min.css";
  // Import Simple Line Icons Set
  $simple-line-font-path: "~simple-line-icons/fonts/";
  @import "~simple-line-icons/css/simple-line-icons.css";

</style>
<style lang="scss">
  // Import Main styles for this application
  @import "./scss/style";
  input[type=text], input[type=date], input[type=date], #description, Multiselect, select {
    z-index: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue?3f37f67c